import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from "@angular/core";
import _, { uniqBy } from "lodash";
import * as moment from "moment";
import { Moment } from "moment";
import { Subject } from "rxjs";
import { tap, takeUntil, share } from "rxjs";
import { PlatformInfo } from "@root/config";
import { TranslateService } from "@root/shared/service/translate.service";
import { InternationalService } from "@root/international.service";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { AppService } from "@root/app.service";
import {
  Child,
  DateRange,
  MultiHouseCalendarService,
  SelectedData,
} from "@root/router/component/calendar/multi-house-calendar/multi-house-calendar.service";

interface DataOfSelectedDates {
  status: "open" | "close" | "diff" | "past";
  list?: {
    0?: Array<any>;
    1?: Array<any>;
  };
}
@Component({
  selector: "host-month-calendar-v2",
  templateUrl: "./month-calendar-v2.component.html",
  styleUrls: ["./month-calendar-v2.component.scss"],
})
export class MonthCalendarV2Component implements OnInit, OnDestroy {
  @Input() @InputBoolean() selectable = true; // 是否可以拖选
  @Input() @InputBoolean() disablePast = false; // 是否过去日期可选
  @Input() @InputBoolean() showLeadPrice = false;
  @Input() @InputBoolean() showLeadRules = false;
  @Input() calendarMap;
  @Input() hourReservationMap = {};
  @Input() channelColorMap = {};
  @Input() taskMap;
  @Input() currentThirdparty;
  @Input() reservationStyle: "status" | "channel" = "status";
  @Input() house: Child;
  @Input()
  set currentDate(value: string) {
    this._currentDate = value;
    this._currentYear = moment(value).year();
    this._currentMonth = moment(value).month();
  }
  @Output() onSelectCell = new EventEmitter<SelectedData<"house", "status">>();
  @Output() onSelectResv = new EventEmitter<string>();
  @Output() onCreateHourResv = new EventEmitter();
  @Output() onClickChangeAvailable = new EventEmitter();
  @Output() onClickChangeTab = new EventEmitter<number>();
  @Output() onClickTask = new EventEmitter();
  @Output() onClickCreateTask = new EventEmitter();
  @Output() onClickEditNote = new EventEmitter();
  @Output() onClickExtendStay = new EventEmitter();
  @Output() monthChange = new EventEmitter();
  // private _id;

  _currentDate = moment().format("YYYY-MM");
  _currentYear = moment().year();
  _currentMonth = moment().month();

  @Input() listOfSelectedDates: DateRange = {
    head: null,
    last: null,
  };

  @Input() selectedReservationCode = null;

  dataOfSelectedDates: DataOfSelectedDates = {
    status: "open",
    list: {},
  };
  dataOfEditNotePop = {
    text: "",
    list: null,
  };
  @Input() selectStatus: "none" | "doing" | "done" = "none";
  displaySelectPop = false;
  displayEditNotePop = false;

  resvPopRefreshFlag = true;
  private token = Math.random();
  /** @deprecated */
  private select$ = this.calendarService.selectRaw$.pipe(
    tap((value) => {
      // console.log('value.token: ', value.token, ' this.token: ', this.token);
      // if (value.token !== this.token) {
      //   return;
      // }

      const { head, last } = value.dates;
      const status = value.status;

      /** 只有本组件发的消息才进行计算。如果没有token，说明不是日历组件，也要处理 */
      if (status === "done" && (value.token === this.token || !value.token)) {
        const sliced = _.filter(
          this.calendarMap,
          (c) => head.isSameOrBefore(c.date, "d") && last.isSameOrAfter(c.date, "d"),
        );

        this.updateDataOfSelectedDates(sliced);
        this.updateDataOfEditNotePop(sliced);
        setTimeout(() => {
          console.log("=============== what is that =============");
          this.displaySelectPop = true;
        }, 500);
      } else {
        this.displaySelectPop = false;
      }
      this.selectStatus = value.status;
      this.listOfSelectedDates = value.dates;
      // this.displaySelectPop = true;
    }),
  );

  /** @deprecated */
  private selectReservation$ = this.calendarService.selectReservationRaw$.pipe(
    tap((value) => {
      this.selectedReservationCode = value;
    }),
  );

  private destroy$ = new Subject();

  get isInternational() {
    return this.app.app.international;
    // return this.international.isInternational();
  }

  constructor(
    private calendarService: MultiHouseCalendarService,
    private translateService: TranslateService,
    private international: InternationalService,
    private app: AppService,
  ) {}

  ngOnInit() {
    // this.select$.pipe(takeUntil(this.destroy$)).subscribe();
    // this.selectReservation$.pipe(takeUntil(this.destroy$)).subscribe();
  }

  toggleSelecting(date) {
    const dateStr = date.title;
    if (
      (this.calendarMap[dateStr] && this.calendarMap[dateStr].reservation) ||
      (this.disablePast && date.date.isBefore(moment(), "d")) ||
      !this.selectable
    ) {
      return;
    }
    this.selectReservation(null);
    if (this.selectStatus === "none" || this.selectStatus === "done") {
      this.selectStatus = "doing";

      this.select({
        head: date.date,
        last: date.date,
      });
      // this.listOfSelectedDates = {
      //   head: date.date,
      //   last: date.date
      // };
    } else {
      this.selectStatus = "done";
      const data = this.listOfSelectedDates;
      /** 结束托选后，需要排一下序，防止反向托选时head大于last */
      const [head, last] = [moment.min(data.head, data.last), moment.max(data.head, data.last)];
      // const house = this.house;
      this.select({ head, last });
    }
  }

  updateSelectedDates(date) {
    if (this.selectStatus !== "doing") {
      return;
    }

    /** 鼠标移动到了订单 */
    if (_.get(this.calendarMap[date.title], "reservation")) {
      return;
    }

    /** 选择了过去日期 */
    if (this.disablePast && date.date.isBefore(moment(), "d")) {
      return;
    }

    const { last } = this.listOfSelectedDates;

    this.select({
      ...this.listOfSelectedDates,
      last: date.date,
    });
    // this.listOfSelectedDates = {
    //   ...this.listOfSelectedDates,
    //   last: date.date
    // };

    /**
     * 做一次全面检查，查看所选日期之内是否有订单
     * 如果有订单，则不允许选中
     */
    const dates = _.filter(_.values(this.calendarMap), (item) => this.isBetween(moment(item.date)));
    if (_.find(dates, (d) => d.reservation)) {
      this.select({
        ...this.listOfSelectedDates,
        last,
      });
      // this.listOfSelectedDates = {
      //   ...this.listOfSelectedDates,
      //   last
      // };
    }
  }

  isBetween(date: Moment) {
    const { head, last } = this.listOfSelectedDates;

    if (!head && !last) {
      return;
    }

    const [_head, _last] = [moment.min(head, last), moment.max(head, last)];

    return moment(date).isSameOrAfter(_head, "d") && moment(date).isSameOrBefore(_last, "d");
  }

  isHead(date: Moment) {
    const { head, last } = this.listOfSelectedDates;
    if (!head && !last) {
      return;
    }
    return moment(date).isSame(moment.min(head, last), "d");
  }

  isLast(date: Moment) {
    const { head, last } = this.listOfSelectedDates;
    if (!head && !last) {
      return;
    }
    return moment(date).isSame(moment.max(head, last), "d");
  }

  getReservationColor(calendar) {
    // const reservation = calendar.__reservation;
    const reservation = calendar.resv;
    if (this.reservationStyle === "channel") {
      /** 按渠道显示订单颜色 */
      const code = reservation.handmade_chanel;
      // const code =
      //   reservation.thirdparty_type === 5
      //     ? reservation.handmade_chanel
      //     : reservation.thirdparty_type === 6
      //       ? 23
      //       : reservation.thirdparty_type;
      const channel = this.channelColorMap[code];
      return channel ? channel.bg_color : "#B9B9B9";
    } else {
      /** 按状态显示订单颜色 */
      return calendar.resvBefore ? "#22975d" : calendar.resvChecking ? "#db5172" : "#3475bc";
    }
  }

  getChannelName(reservation) {
    if (reservation.thirdparty_type === 5) {
      /** 取渠道名 */

      // return this.translateService.syncGet('word.channel_' + reservation.handmade_chanel);

      const channel = this.channelColorMap[reservation.handmade_chanel];
      if (channel) {
        return channel.channel_name;
      }
    } else {
      /** 取平台名 */
      return this.translateService.t("word.channel_" + reservation.thirdparty_type);

      const platform = PlatformInfo[reservation.thirdparty_type];
      if (platform) {
        return platform.name;
      }
    }
  }

  updateDataOfSelectedDates(calendars = []) {
    if (_.isEmpty(calendars)) {
      return;
    }

    let status: "open" | "close" | "diff" | "past" = "open";
    let list = null;

    const head = _.head(calendars);
    if (head.type === "past") {
      this.dataOfSelectedDates = { status: "past", list };
      return;
    }

    if (calendars.length === 1) {
      /**
       * 单天分为 打开  关闭  不一致三种状态
       * 其中不一致状态需要显示具体不一致的渠道信息
       */
      const calendar = _.head(calendars) || {};
      if (calendar.available === 0) {
        status = "close";
      } else if (calendar.available === 1) {
        status = "open";
      } else {
        status = "diff";

        list = _.groupBy(calendar.housing_status, "available");
      }
    } else {
      /**
       * 多天分为 打开  关闭  不一致三种状态
       * 不一致状态不需要显示具体渠道信息
       */
      if (_.every(calendars, (calendar) => calendar.available === 0)) {
        status = "close";
      } else if (_.every(calendars, (calendar) => calendar.available === 1)) {
        status = "open";
      } else {
        status = "diff";
      }
    }

    this.dataOfSelectedDates = { status, list };
  }

  updateDataOfEditNotePop(calendar: any[]) {
    const result = uniqBy(calendar, "note");
    const list = calendar?.map((item) => item.date);
    if (result?.length === 1) {
      this.dataOfEditNotePop = { text: result[0].note, list };
    } else {
      this.dataOfEditNotePop = { text: null, list };
    }
  }

  displayHourReservationPanel(date, event) {
    event.stopPropagation();
    const param = {
      house: {
        id: this.house.c_id,
        house_title: this.house.c_title,
      },
      date: date,
    };

    this.onCreateHourResv.emit(param);
    // this.calendarService.displayHourReservationSidebar(param);
  }
  onClickHourOrder(event, date: string) {
    event.stopPropagation();

    const orders = this.hourReservationMap[date] || [];

    if (moment().isAfter(date, "d")) {
      const code = _.get(_.last(orders), "code");
      this.selectReservation(code);
    } else if (moment().isBefore(date, "d")) {
      const code = _.get(_.head(orders), "code");
      this.selectReservation(code);
    } else {
      let min = Infinity;
      let code;
      orders.forEach((order) => {
        const diff = moment().diff(`${order.check_in} ${order.start_time}`, "m");
        if (diff < min) {
          min = diff;
          code = order.code;
        }
      });
      this.selectReservation(code);
    }
  }

  isHourReservationSelected(date: string) {
    const orders = this.hourReservationMap[date] || [];
    const code = this.selectedReservationCode;
    return !!_.find(orders, { code });
  }

  onClickReservation(code) {
    this.listOfSelectedDates = {
      head: null,
      last: null,
    };
    // this.select({ head: null, last: null });
    // this.calendarService.cancelSelect();
    this.resvPopRefreshFlag = false;
    setTimeout(() => {
      this.resvPopRefreshFlag = true;
    }, 300);
    this.selectReservation(code);
  }

  onClickTasks(event, tasks: any[]) {
    event.stopPropagation();

    this.listOfSelectedDates = {
      head: null,
      last: null,
    };

    const task = _.head(tasks);
    this.onClickTask.emit(task);
    // this.calendarService.displayTaskSidebar(task);
  }

  onCreateTask(event, date: string) {
    event.stopPropagation();

    this.onClickCreateTask.emit(date);
  }

  onExtendStay(code) {
    this.onClickExtendStay.emit(code);
  }

  onSaveEditNote(data) {
    this.onClickEditNote.emit({
      note: data,
      date_list: JSON.stringify(this.dataOfEditNotePop.list),
    });
    this.displayEditNotePop = false;
    // this.displaySelectPop = false;
  }

  onCancelEditNote() {
    this.displayEditNotePop = false;
    this.displaySelectPop = false;
  }

  price(date) {
    const calendar = _.get(this.calendarMap, `${date.title}`);
    if (!calendar) {
      return;
    }

    const price = _.find(calendar.prices, {
      thirdparty_type: this.currentThirdparty,
    });
    return price;
  }

  changeHouseAvailable(status: 0 | 1, event) {
    // if (!this.hasWritePermission()) {
    //   this.modalService.warning({
    //     nzTitle: '暂无修改权限，请联系管理员'
    //   });
    //   return;
    // }
    event.stopPropagation();
    const { head, last } = this.listOfSelectedDates;
    this.onClickChangeAvailable.emit({
      id: this.house.c_id,
      head: moment(head).format("YYYY-MM-DD"),
      last: moment(last).format("YYYY-MM-DD"),
      status,
    });
    this.calendarService.cancelSelect();
  }

  changeTab(tabName, event) {
    event.stopPropagation();
    this.onClickChangeTab.emit(tabName);
    this.displaySelectPop = false;
    // this.calendarService.changeTab(index);
  }
  select(value) {
    const { head, last } = value;
    const status = this.selectStatus;

    /** 只有本组件发的消息才进行计算。如果没有token，说明不是日历组件，也要处理 */
    if (status === "done") {
      const sliced = _.filter(
        this.calendarMap,
        (c) => head.isSameOrBefore(c.date, "d") && last.isSameOrAfter(c.date, "d"),
      );

      this.updateDataOfSelectedDates(sliced);
      this.updateDataOfEditNotePop(sliced);
      setTimeout(() => {
        console.log("=============== what is that =============");
        this.displaySelectPop = true;
      }, 500);
    } else {
      this.displaySelectPop = false;
    }
    this.listOfSelectedDates = value;

    this.onSelectCell.emit({
      status: this.selectStatus,
      dates: { ...value },
      data: {
        type: "house",
        payload: this.house,
      },
    });
    return;
    this.calendarService.select({
      status: this.selectStatus,
      dates: {
        ...value,
      },
      data: {
        type: "house",
        payload: this.house,
      },
      token: this.token,
    });
  }

  selectReservation(code) {
    this.selectedReservationCode = code;
    this.onSelectResv.emit(code);
    // this.calendarService.selectReservation(code);
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
